import { render, staticRenderFns } from "./zdrugDetail.vue?vue&type=template&id=45e044e9&scoped=true"
import script from "./zdrugDetail.vue?vue&type=script&lang=js"
export * from "./zdrugDetail.vue?vue&type=script&lang=js"
import style0 from "./zdrugDetail.vue?vue&type=style&index=0&id=45e044e9&prod&scoped=true&lang=css"
import style1 from "./zdrugDetail.vue?vue&type=style&index=1&id=45e044e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e044e9",
  null
  
)

export default component.exports